export class ClassToggler {
  constructor(element, classesToToggle) {
    this._element = element
    this._classListToToggle = classesToToggle.split(' ')
  }

  removeClass(klass) {
    this._element.classList.remove(klass)
  }

  addClass(klass) {
    this._element.classList.add(klass)
  }

  containsClass(klass) {
    return this._element.classList.contains(klass)
  }

  removeAllClasses() {
    for (let index = 0; index < this._classListToToggle.length; index++) {
      if (this.containsClass(this._classListToToggle[index])) { this.removeClass(this._classListToToggle[index]) }
    }
  }

  addAllClasses() {
    for (let index = 0; index < this._classListToToggle.length; index++) {
      if (!this.containsClass(this._classListToToggle[index])) { this.addClass(this._classListToToggle[index]) }
    }
  }

  toggleAllClasses() {
    let klass
    for (let index = 0; index < this._classListToToggle.length; index++) {
      klass = this._classListToToggle[index]
      if (this.containsClass(klass)) {
        this.removeClass(klass)
      } else {
        this.addClass(klass)
      }
    }
  }
}
